"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryGoalGroupToJSON = exports.DeliveryGoalGroupFromJSONTyped = exports.DeliveryGoalGroupFromJSON = exports.DeliveryGoalGroup = void 0;
/**
 * deliveryGoal group grouping selection for a campaign.
 * @export
 */
exports.DeliveryGoalGroup = {
    Unset: 'UNSET',
    Awareness: 'AWARENESS',
    WebsiteTraffic: 'WEBSITE_TRAFFIC',
    AppPromotion: 'APP_PROMOTION',
    EngagementOnSpotify: 'ENGAGEMENT_ON_SPOTIFY'
};
function DeliveryGoalGroupFromJSON(json) {
    return DeliveryGoalGroupFromJSONTyped(json, false);
}
exports.DeliveryGoalGroupFromJSON = DeliveryGoalGroupFromJSON;
function DeliveryGoalGroupFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.DeliveryGoalGroupFromJSONTyped = DeliveryGoalGroupFromJSONTyped;
function DeliveryGoalGroupToJSON(value) {
    return value;
}
exports.DeliveryGoalGroupToJSON = DeliveryGoalGroupToJSON;
